<nav class="top-menu-nav">
  @if (hasStations) {
    <div class="top-menu-nav__book-item" (click)="onBookNowClick()">
      <span>{{headerCopy.bookNow}}</span>
    </div>
  }
  <div class="top-menu-nav-list">
    @if (hasStations) {
      <div class="top-menu-nav-list__item" [routerLink]="headerCopy.manageTrip.link" routerLinkActive="active">
        {{headerCopy.manageTrip.name}}
      </div>
    }
    @if (hasStations) {
      <div class="top-menu-nav-list__item" [routerLink]="headerCopy.destinations.link" routerLinkActive="active">
        {{headerCopy.destinations.name}}
      </div>
    }
    <div class="top-menu-nav-list__item" [routerLink]="headerCopy.support.link" routerLinkActive="active">
      {{headerCopy.support.name}}
    </div>
    @if (hasStations) {
      <app-top-menu-travel-info-menu
        [headerCopy]="headerCopy"
        [isFlifoEnabled]="isFlifoEnabled"
      ></app-top-menu-travel-info-menu>
    }
  </div>
</nav>